import React from 'react';
import { View, Text, Pressable } from 'react-native';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import theme from '../../theme';

export default function FaqItem({ q, a, open, onToggle }) {
  return (
    <Pressable
      onPress={onToggle}
      style={{
        borderBottomWidth: theme.borderWidth.thin,
        borderBottomColor: theme.colors.borderDefault,
        paddingVertical: 18,
      }}
    >
      <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
        <Text style={{ fontFamily: theme.typography.fontSans, fontWeight: theme.typography.weight.medium, fontSize: theme.typography.size.base }}>
          {q}
        </Text>
        {open ? (
          <RemoveIcon style={{ width: 18, height: 18, color: theme.colors.textTertiary }} />
        ) : (
          <AddIcon style={{ width: 18, height: 18, color: theme.colors.textTertiary }} />
        )}
      </View>
      {open && (
        <Text
          style={{
            fontFamily: theme.typography.fontSans,
            fontSize: theme.typography.size.sm,
            color: theme.colors.textSecondary,
            lineHeight: theme.lineHeightPx(theme.typography.size.sm, 'normal'),
            marginTop: 12,
            maxWidth: 620,
          }}
        >
          {a}
        </Text>
      )}
    </Pressable>
  );
}